<template>
  <div
    class="getLayoutContentMode"
    :style="frameSty"
    id="PageLayout"
    :class="[prefixCls, getLayoutContentMode,getShowBreadCrumb?'showBreadCrumb':'notShowBreadCrumb',pageTitleFlag&&showCurPageHeader&&getShowBreadCrumb&&getPageName?'hasPageBar':pageTitleFlag?'noHasPageBar':'']"
    v-loading="getOpenPageLoading && getPageLoading"
  >
    <div class="page-header-bar w100b"
         v-if="pageTitleFlag&&getShowBreadCrumb&&getPageName&&showCurPageHeader&&singlePageFlag!==true">
      <div class="page-title">
        {{ getPageName }}
      </div>
    </div>

    <div
      class="getLayoutContentModeBg"
      :style="LayoutContentSty"
    >
      <div class="portal-workbench-background-mask" :style="maskSty"></div>
    </div>
    <PageLayout :analysisSet="analysisSet" style="z-index: 100" class="wh100b PageLayout" />
  </div>
</template>
<script lang="ts" setup>
  import PageLayout from '@/layouts/page/index.vue';
  import { useDesign } from '@/hooks/web/useDesign';
  import { useRootSetting } from '@/hooks/setting/useRootSetting';
  import { useTransitionSetting } from '@/hooks/setting/useTransitionSetting';
  import { useContentViewHeight } from './useContentViewHeight';
  import { useHeaderSetting } from '@/hooks/setting/useHeaderSetting';
  import {useAppStore} from "@/store/modules/app";
  import extendList from "@/layouts/data/extendList";

  function initHeaderBar(toPath){
    for(let num=0;num<extendList.length;num++){
      let pathUrl=extendList[num];
      if(pathUrl.indexOf("*")>0){
        pathUrl=pathUrl.replace("**",'');
        if(toPath.indexOf(pathUrl)>=0){
          showCurPageHeader.value=false;
          break;
        }else{
          showCurPageHeader.value=true;
        }
      }else{
        if(pathUrl===toPath){
          showCurPageHeader.value=false;
          break;
        }else{
          showCurPageHeader.value=true;
        }
      }
    }
  }
  const appStore = useAppStore();
  const props=defineProps({
    singlePageFlag:{},
    analysisSet:{
      type:Boolean,
      default:false
    },
    pageTitleFlag:{
      type:Boolean,
      default:false
    },
    headerHeight:{
      type:Number,
      default:48
    }
  });
  const showCurPageHeader=ref(true);

  const router = useRouter();
  initHeaderBar(router.currentRoute.value.path);

  watch(() => router.currentRoute.value.path,(toPath) => {
    initHeaderBar(toPath);
    //要执行的方法
  })

  const { getShowBreadCrumb,getPageName } = useRootSetting();
  const {
    getPageBgOpAcityVal,
    getPageBgFilterVal,
    getPageBgImgSrc,
    getBackShowType,
    getMaskColor,
    getPageBgColor,
  } = useHeaderSetting();

  const isMatchedMenu = ref(false);

  const LayoutContentSty = computed(() => {
    let sty:any = {
      backgroundColor: unref(getPageBgColor),
      backgroundImage: `url(${unref(getPageBgImgSrc)})`,
      filter: `blur(${unref(getPageBgFilterVal) || 10}px`,
    };
    //如果是图片背景
    if(unref(getBackShowType) !== 'imgBg'){
      delete sty['backgroundImage'];
      delete sty['filter'];
    }else{
      sty['filter']='blur(1px)';
    }
    return sty;
  });
  const { prefixCls } = useDesign('layout-content');
  const { getOpenPageLoading } = useTransitionSetting();
  const { getLayoutContentMode, getPageLoading } = useRootSetting();

  useContentViewHeight();
  const maskSty = computed(() => {
    if (unref(getPageBgOpAcityVal)) {
      return {
        opacity: `${parseInt(unref(getPageBgOpAcityVal)) / 100}`,
        backgroundColor: unref(getMaskColor) || 'rgb(255, 255, 255)',
      };
    } else {
      return {};
    }
  });

  const frameSty = computed(() => {
    return {
      height: `calc(100% - ${props.headerHeight}px)`,
      overflowY: 'auto',
      overflowX: 'hidden',
    };
  });

</script>
<style lang="less">
  .getLayoutContentMode {
    flex-wrap: wrap;

    &.noHasPageBar{
      #frame{
         padding:0
      }
      &.notShowBreadCrumb{
        #frame{
          position: relative;
          z-index: 10;
          padding: 12px;
        }
      }
    }
    &.hasPageBar{
      #frame{
        height:calc(100% - 56px);
      }
      > div {
        height:calc(100% - 56px);
      }
    }
    > div {
      width: 100%;
      position: relative;
      // height: calc(100% - 100px); //减去面包屑的高度
      height: 100%; //减去面包屑的高度
      z-index: 10;
    }
    >.getLayoutContentModeBg{
      z-index: 3;
    }

    >div.page-header-bar{
      height: 56px;
      background: #FFFFFF;
      box-shadow: inset 0px -1px 0px 0px #E5E6EB;
      z-index: 31;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 12px;
      .page-title{
        font-size: 20px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: #1D2129;
        line-height: 28px;
      }
    }
  }

  .getLayoutContentMode {
    background-color: var(--page-bg-color);

    .portal-workbench-background-mask {
      width: 100%;
      height: 100%;
    }

    .getLayoutContentModeBg {
      position: absolute;
      z-index: 1;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      overflow: hidden;
      width: 100%;
      height: 100%;
      background-size: cover;
      filter: blur(14px);
    }
  }

  @prefix-cls: ~'@{namespace}-layout-content';

  .@{prefix-cls} {
    position: relative;
    flex: 1 1 auto;
    min-height: 0;

    &.fixed {
      width: 1200px;
      margin: 0 auto;
    }

    &-loading {
      position: absolute;
      top: 200px;
      z-index: @page-loading-z-index;
    }
  }
</style>
